/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { initializeApp } from 'firebase/app';
import { getAuth, signInWithPopup, GoogleAuthProvider, onAuthStateChanged, signOut } from "firebase/auth";
import { updateLocationURL } from '../reducers/appSlice.js';    // Import used to redirect page when user not logged in or when user logged out
import {dataurl} from '../components/paksh-constants.js'  // Import used to separate development urls from production


// This import loads the firebase namespace followed by imports load individual services into the firebase namespace.


const initialState = {
  firebaseinitialized : false,
  user : {}
};



const firebaseConfig = {
  apiKey: "AIzaSyAIdtFfKz4D99e7aUVXXTrpuprt68ObWE0",
  authDomain: "paksh-app.firebaseapp.com",
  databaseURL: "https://paksh-app.firebaseio.com",
  projectId: "paksh-app",
  storageBucket: "paksh-app.appspot.com",
  messagingSenderId: "405654242351",
  appId: "1:405654242351:web:f5453a1523213dc5eff2da"
}

const firebaseApp = initializeApp(firebaseConfig)
const FirebaseAuth = getAuth();
const provider = new GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/userinfo.profile');

// -------------------------------------------------------------------------------------------------
// Initialize the GAPI JavaScript client library.
// -------------------------------------------------------------------------------------------------



// -------------------------------------------------------------------------------------------------
// function to return FirebaseAuth. It is the Firebase app instance returned from intialization of firebase.
// A Firebase App holds the initialization information for a collection of services.
// -------------------------------------------------------------------------------------------------

export const initAuth = (dispatch) => {
  if (FirebaseAuth) {
    return Promise.resolve(FirebaseAuth);
    // The Promise.resolve() method returns a Promise object that is resolved with a given value.
    // If the value is a promise, that promise is returned; if the value is a thenable (i.e. has a "then" method),
    // the returned promise will "follow" that thenable, adopting its eventual state; otherwise the returned promise will be fulfilled
    // with the value
  }
//  if (!firebase.apps.length) {   // trick to avoid intialization getting called twice.  NOT USED

    FirebaseAuth = initializeApp({firebaseConfig})

    return Promise.resolve(FirebaseAuth);

};

export const signIn = () => (dispatch) =>   { signInWithPopup(FirebaseAuth, provider)
  .then((result) => {
    // This gives you a Google Access Token. You can use it to access the Google API.
    dispatch(authInitialized());
    const credential = GoogleAuthProvider.credentialFromResult(result);
    const token = credential.accessToken;
    // The signed-in user info.
     console.log("signIn: before userGet")
    getUserFromFirebaseUser(result.user)
     console.log("signIn: after userGet")
    // IdP data available using getAdditionalUserInfo(result)
    // ...
  }).catch((error) => {
    // Handle Errors here.
    const errorCode = error.code;
    const errorMessage = error.message;
    // The email of the user's account used.
    // const email = error.customData.email;
    // The AuthCredential type that was used.
    const credential = GoogleAuthProvider.credentialFromError(error);
    // ...
  });
};


// -------------------------------------------------------------------------------------------------
// (1) Signout (2)store blank user in state (3) redirect to public page
// -------------------------------------------------------------------------------------------------
export const signEnd = (FirebaseAuth) => (dispatch) => {
  // console.log("in SignEnd")
  const FirebaseAuth = getAuth();
  signOut(FirebaseAuth).then(() => {
          // Sign-out successful.
        }).catch((error) => {
          // An error happened.
        });
        dispatch(userSet());
        window.localStorage.removeItem('token');
      dispatch(updateLocationURL('/public'))    // ------FIX FOR BUILD----
};

//  ------------------------
//  For user already authenticated using Firebase Auth
//  Get data from firestore User collection if does not exist then add the user to the firestore collection
// -------------------------
//  ------------------------
//  For user already authenticated using Firebase Auth
//  Get data from firestore User collection if does not exist then add the user to the firestore collection
// -------------------------
export const fetchUser = () => (dispatch) => {
  initAuth(dispatch).then(() => {
    // const auth = getAuth();
    onAuthStateChanged(FirebaseAuth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/auth.user
        console.log(user)
        const uid = user.uid;
        dispatch(getUserFromFirebaseUser(user));
        // ...
      } else {
        // User is signed out
        return false
      }
    });
  });
};

// -------------------------------------------------------------------------------------------------
//
// -------------------------------------------------------------------------------------------------

export const getUserFromFirebaseUser = (user)  => (dispatch) => {
  // console.log("action auth.js/getUserFromFirebaseUser:---- enter")
  let profile = {
    uid: user.uid,
    displayName: user.displayName,
    email: user.email,
    photoUrl: user.photoURL
  }
  user.getIdToken().then((token) => {
     window.localStorage.setItem('token', token);
  });

   fetch(`${dataurl}/users/one`, {
    headers: {
      'x-access-token': profile.uid,
    },
    method: "GET"
  })   // get user proile
    .then(res => {
      if (res.status === 200) {      // user is  registered
        // console.log("1 user profile found in firestore db")
        res.json().then(data => {
            //  profile["status" : "lead";
            if (!data.error) {     // if profile read properly from firestore db use that
              if (data.docinfo.status !== "approved") {
                updateLocationURL('/public') // if user is not approved then send them to public page
              }
              else {
                profile = { ...profile ,
                  "court" :data.docinfo.court,
                  "admin" : data.docinfo.admin,
                  // "calendarId" : data.docinfo.calendarId,
                  // "lastColorId" : data.docinfo.lastColorId,
                  "status" : data.docinfo.status,
                  "favlawyers" : data.docinfo.favlawyers,
                }
                // console.log ("2 getUserFromFirebaseUser: ready to saveuser ")
                // console.log(profile)
                dispatch(userSet(profile))
                saveUser(profile.uid , profile);
                // console.log ("3 getUserFromFirebaseUser: after saveUser")
              }
            }
            else {
                // console.log("4 getUserFromFirebaseUser: in data error ")
                addUser(profile.uid , profile);
            }
        })
      }
      else {
        profile = { ...profile ,
          "status" : "approved"
        }
        saveUser(profile.uid , profile);  // ---- FIX FOR BUILD ----
        // console.log("5 retun else")
      }

    })
  // console.log("retun profile")
  // console.log(profile)
    return profile
};


// -------------------------------------------------------------------------------------------------
//
// -------------------------------------------------------------------------------------------------

export const saveUser = (id, data) =>  {
  // console.log("saveUser: before post")
  // console.log(data)
  let token = window.localStorage.getItem('token');
   fetch(`${dataurl}/users/updateUser`,
    {
      headers: {
        'x-access-token': token,
          },
      method: "POST",
      body: JSON.stringify(data)
    }
    )// .then(dispatch(addUser(data)))   //  ---  Check why need store. for dispatch
    // console.log("saveUser:  after post")
  };

// -------------------------------------------------------------------------------------------------
//  Firebase auth is done after GAPI Auth
// -------------------------------------------------------------------------------------------------

//const authInitialized = () => ({
//    type: AUTH_INITIALIZED
//  });


// -------------------------------------------------------------------------------------------------
//   TODO:  NOT USED COULD BE DELETED
// -------------------------------------------------------------------------------------------------

export const isUserSignedIn = () =>
  //  export const isUserSignedIn = () => (dispatch) => {
  // console.log(dispatch)
  //   initAuth(dispatch).then(() => {
  // console.log(firebase.auth())
   !!firebase.auth().currentUser
  //   });
;


export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authInitialized(state, action) {
      return {
        ...state,
        firebaseinitialized: true
      };
    },
    userSet(state, action) {
      console.log("payload")
      console.log(action.payload)
      return {
        ...state,
        user: action.payload
      };
    },
    addUser(state, action) {
      return action.payload
    },
  }
})

export const { authInitialized, userSet, addUser } = authSlice.actions

// Export the slice reducer as the default export
export default authSlice.reducer